// curl -X 'GET' \
//   'https://api-developers.jago.cloud/api/v2/users?page=0&pageSize=10&roleIds=0&roleIds=1&roleIds=2&orderDir=DESC&orderBy=id' \
//   -H 'accept: */*'

import { useState } from 'react';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
//import { useLogout } from './useLogout';
import { useSelector } from 'react-redux';


const useUser = () =>{
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    //const logout = useLogout();

    //const token = useSelector((state)=>state.user.token);
    const token = useSelector((state)=>state.user.itoken);
    const MIDDLEWARE_HOST = process.env.REACT_APP_API_MIDDLEWARE_URL;

    const HOST = process.env.REACT_APP_API_MIDDLEWARE_URL;

    const dispatch = useDispatch();

    const getUsers = async(onSuccess,onError) =>{
        const headers = {
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
        };
      try {
        setLoading(true);

        axios.get(
            `${MIDDLEWARE_HOST}/api/v2/users?page=0&pageSize=200&roleIds=1&roleIds=5&orderDir=DESC&orderBy=id`,
          {
            headers,
          }
        ).then(
          (response) => {
            if(response.status === 200){
                onSuccess(response.data);
            }else{
              onError(`Errore, Riprova piu tardi Code:${response.status}`)
            }
          },
          (error) => {
            setError("Errore, Riprova piu tardi");
            onError(`Errore, Riprova piu tardi`)
          }
        ).finally(() => {setLoading(false)});
      }catch (error) {
        setError("Errore, Riprova piu tardi");
        onError(`Errore, Riprova piu tardi`)
      }

    }

    const createUser = async(userData,onSuccess,onError) =>{
        const headers = {
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
        };
      try {
        setLoading(true);

        axios.post(
            `${MIDDLEWARE_HOST}/api/v1/users`,
            userData,
          {
            headers,
          }
        ).then(
          (response) => {
            if(response.status === 200 || response.status === 201){
                onSuccess(response.data);
            }else{
              onError(`Errore, Riprova piu tardi Code:${response.status}`)
            }
          },
          (error) => {
            setError("Errore, Riprova piu tardi");
            onError(`Errore, Riprova piu tardi`)
          }
        ).finally(() => {setLoading(false)});
      }catch (error) {
        setError("Errore, Riprova piu tardi");
        onError(`Errore, Riprova piu tardi`)
      }

    }

    const editUser = async(userId,userData,onSuccess,onError) =>{
        const headers = {
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
        };
      try {
        setLoading(true);

        axios.put(
            `${HOST}/api/v2/users/${userId}`,
            userData,
          {
            headers,
          }
        ).then(
          (response) => {
            if(response.status === 200 || response.status === 201){
                onSuccess(response.data);
            }else{
              onError(`Errore, Riprova piu tardi Code:${response.status}`)
            }
          },
          (error) => {
            setError("Errore, Riprova piu tardi");
            onError(`Errore, Riprova piu tardi`)
          }
        ).finally(() => {setLoading(false)});
      }catch (error) {
        setError("Errore, Riprova piu tardi");
        onError(`Errore, Riprova piu tardi`)
      }

    }

    const changeUserStatus = async(userId,change,onSuccess,onError) =>{
        const headers = {
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
        };
      try {
        setLoading(true);

        axios.post(
          `${HOST}/api/v2/users/${userId}/${change}`,
          {},
          {
            headers,
          }
        ).then(
          (response) => {
            if(response.status === 200 || response.status === 201){
                onSuccess(response.data);
            }else{
              onError(`Errore, Riprova piu tardi Code:${response.status}`)
            }
          },
          (error) => {
            setError("Errore, Riprova piu tardi");
            onError(`Errore, Riprova piu tardi`)
          }
        ).finally(() => {setLoading(false)});
      }catch (error) {
        setError("Errore, Riprova piu tardi");
        onError(`Errore, Riprova piu tardi`)
      }

    }

    const resetPassword = async(userId,onSuccess,onError) =>{
        const headers = {
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
        };
      try {
        setLoading(true);

        axios.post(
          `${HOST}/api/v2/users/${userId}/resetPassword`,
          {},
          {
            headers,
          }
        ).then(
          (response) => {
            if(response.status === 200 || response.status === 201){
                onSuccess(response.data);
            }else{
              onError(`Errore, Riprova piu tardi Code:${response.status}`)
            }
          },
          (error) => {
            setError("Errore, Riprova piu tardi");
            onError(`Errore, Riprova piu tardi`)
          }
        ).finally(() => {setLoading(false)});
      }catch (error) {
        setError("Errore, Riprova piu tardi");
        onError(`Errore, Riprova piu tardi`)
      }

    }

    const deleteUser = async(userId,onSuccess,onError) =>{
        const headers = {
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
        };
      try {
        setLoading(true);

        axios.delete(
          `${HOST}/api/v2/users/${userId}?anonymizeAllEvents=false&deleteAllStandardDevices=false`,
          {
            headers,
          }
        ).then(
          (response) => {
            if(response.status === 200 || response.status === 201){
                onSuccess(response.data);
            }else{
              onError(`Errore, Riprova piu tardi Code:${response.status}`)
            }
          },
          (error) => {
            setError("Errore, Riprova piu tardi");
            onError(`Errore, Riprova piu tardi`)
          }
        ).finally(() => {setLoading(false)});
      }catch (error) {
        setError("Errore, Riprova piu tardi");
        onError(`Errore, Riprova piu tardi`)
      }

    }

    const getRoles = async(onSuccess,onError,tk=null) =>{
      const headers = {
            Accept: "*/*",
            Authorization: `Bearer ${tk??token}`,
        };
      try {
        setLoading(true);

        axios.get(
            `${MIDDLEWARE_HOST}/api/v1/users/roles`,
          {
            headers,
          }
        ).then(
          (response) => {
            if(response.status === 200){
                onSuccess(response.data);
            }else{
              onError(`Errore ruoli, Riprova piu tardi Code:${response.status}`)
            }
          },
          (error) => {
            setError("Errore ruoli, Riprova piu tardi");
            onError(`Errore ruoli, Riprova piu tardi`)
          }
        ).finally(() => {setLoading(false)});
      }catch (error) {
        setError("Errore role, Riprova piu tardi");
        onError(`Errore role, Riprova piu tardi`)
      }

    };



    return { getUsers, createUser, editUser, changeUserStatus, resetPassword, deleteUser, getRoles, userLoading:loading, userError:error };
};

export default useUser;